import carteVoeux26Cover from "../../assets/img/carteVoeux26-cover.webp";

import cadavreExquisCover from "../../assets/img/cadavre-exquis-cover.webp";

import introduceYourselfCover from "../../assets/img/introduce-yourself-cover.webp";
import introduceYourselfCharacters from "../../assets/img/introduce-yourself-characters.webp";

import boSetterlindCover from "../../assets/img/bo-setterlind-cover.webp";

import gardenLifeCover from "../../assets/img/garden-life-cover.webp";

import bdlpCover from "../../assets/img/bdlp-cover.webp";
import bdlpPoster1 from "../../assets/img/bdlp-poster-01.webp";
import bdlpPoster2 from "../../assets/img/bdlp-poster-02.webp";
import bdlpInsta from "../../assets/img/bdlp-poster-insta.webp";
import bdlpPosterMockup from "../../assets/img/bdlp-poster-mockup.webp";

import ellesCover from "../../assets/img/elles-cover.webp";
import ellesFanzine01 from "../../assets/img/ellesFanzine-01.webp";
import ellesFanzine02 from "../../assets/img/ellesFanzine-02.webp";
import ellesPlanche01 from "../../assets/img/ellesPlanche-01.webp";
import ellesPlanche02 from "../../assets/img/ellesPlanche-02.webp";

import matinBrunCover from "../../assets/img/matin-brun-cover.webp";
import matinBrunInterior from "../../assets/img/matin-brun-interior.webp";

import bamCover from "../../assets/img/bam-cover.webp";
import bam01 from "../../assets/img/bam-01.webp";
import bam02 from "../../assets/img/bam-02.webp";
import bam03 from "../../assets/img/bam-03.webp";
import bam04 from "../../assets/img/bam-04.webp";
import bam05 from "../../assets/img/bam-05.webp";
import bam06 from "../../assets/img/bam-06.webp";

import operationCocktailCover from "../../assets/img/operation-cocktail-cover.webp";
import operationCocktail00 from "../../assets/img/operation-cocktail-00.webp";
import operationCocktail01 from "../../assets/img/operation-cocktail-01.webp";
import operationCocktail02 from "../../assets/img/operation-cocktail-02.webp";
import operationCocktail03 from "../../assets/img/operation-cocktail-03.webp";
import operationCocktail04 from "../../assets/img/operation-cocktail-04.webp";
import operationCocktail05 from "../../assets/img/operation-cocktail-05.webp";

import amasaCover from "../../assets/img/amasa-cover.webp";
import amasa00 from "../../assets/img/amasa-00.webp";
import amasa01 from "../../assets/img/amasa-01.webp";
import amasa02 from "../../assets/img/amasa-02.webp";
import amasa03 from "../../assets/img/amasa-03.webp";
import amasa04 from "../../assets/img/amasa-04.webp";
import amasa05 from "../../assets/img/amasa-05.webp";
import amasaStore from "../../assets/img/amasa-store.webp";

import bagnoletCover from "../../assets/img/bagnolet-cover.svg";
import bagnoletTypo01 from "../../assets/img/bagnolet-01.svg";
import bagnoletTypo02 from "../../assets/img/bagnolet-02.svg";
import bagnoletTypo03 from "../../assets/img/bagnolet-03.svg";
import bagnoletArchitecture01 from "../../assets/img/bagnoletArchitecture-01.webp";
import bagnoletEx01 from "../../assets/img/bagnoletEx-01.svg";
import bagnoletEx02 from "../../assets/img/bagnoletEx-02.svg";
import bagnoletArchitecture02 from "../../assets/img/bagnoletArchitecture-02.webp";
import bagnoletArchitecture03 from "../../assets/img/bagnoletArchitecture-03.webp";
import bagnoletArchitecture04 from "../../assets/img/bagnoletArchitecture-04.webp";

import volapukCover from "../../assets/img/volapuk-cover.webp";
import volapukAlphabet from "../../assets/img/volapuk-alphabet.svg";
import volapukCroquis01 from "../../assets/img/volapuk-croquis-01.webp";
import volapukCroquis02 from "../../assets/img/volapuk-croquis-02.webp";

import innocenceDangerCover from "../../assets/img/innocence-en-danger-cover.webp";
import innocenceDangerPoster01 from "../../assets/img/innocence-en-danger-poster-01.webp";
import innocenceDangerPoster02 from "../../assets/img/innocence-en-danger-poster-02.webp";
import innocenceDangerPoster03 from "../../assets/img/innocence-en-danger-poster-03.webp";

import kasaCover from "../../assets/img/kasa-cover.webp";

import portfolioCover from "../../assets/img/portfolio-cover.webp";
import portfolioHome from "../../assets/img/portfolio-home.webp";
import portfolioMenu from "../../assets/img/portfolio-menu.webp";
import portfolioContact from "../../assets/img/portfolio-contact.webp";
import portfolioLogin from "../../assets/img/portfolio-login.webp";

import ridingCitiesCover from "../../assets/img/riding-cities-cover.webp";

export const projectsData = [
  {
    category: "Identité visuelle",
    projects: [
      {
        id: "bdlp",
        category: "Identité visuelle",
        title: "BICENTENAIRE DE LA PHOTOGRAPHIE",
        date: "2025",
        brief:
          "Conception et réalisation de l’identité visuelle du Bicentenaire de la photographie, organisé par le ministère de la Culture.",
        softwares: ["Photoshop", "Illustrator", "InDesign"],
        creativeProcess:
          "Le Bicentenaire de la Photographie célèbre 200 ans d’innovations visuelles et de patrimoine photographique. L’identité visuelle mêle photographie ancienne et numérique : les images d’archives, traitées en noir et blanc avec du grain, évoquent l’ère argentique, tandis que le carré, fait référence au pixel, à la data, et à l’univers de la photographie numérique. Ensemble, ces éléments incarnent la déconstruction et la recomposition qui traversent l’histoire de la photographie. Le logo s’inspire de celui du ministère de la Culture, avec l’idée de « sortir du cadre ». Il évoque à la fois le cadre photographique et, dans notre monde contemporain, la perte de contrôle sur nos données personnelles, comme si l’image, tout comme nos données, ne nous appartenait plus tout à fait.",
        imageUrl: bdlpCover,
        width: 600,
        height: 400,
        link: "/projets/bdlp",
        medias: [
          {
            type: "image",
            src: bdlpPosterMockup,
            alt: "Mockup de la première affiche du Bdlp",
          },
          {
            type: "image",
            src: bdlpPoster1,
            alt: "Première affiche du Bdlp",
          },
          {
            type: "image",
            src: bdlpPoster2,
            alt: "Deuxième affiche du Bdlp",
          },
          {
            type: "image",
            src: bdlpInsta,
            alt: "Instagram du Bdlp",
          },
        ],
      },
    ],
  },
  {
    category: "Édition",
    projects: [
      {
        id: "elles",
        category: "Édition",
        title: "ÉDITION COLLECTIVE : DU TEMPS FILMIQUE AU TEMPS DU LIVRE",
        date: "2025",
        brief:
          "Conception et réalisation d'une planche pour un fanzine collaboratif, à partir de films disponibles sur la plateforme Henri de la Cinémathèque Française.",
        softwares: ["InDesign", "Papier découpé", "Risographie"],
        creativeProcess:
          "Cette planche reprend des captures d’écran du film Elles d’Ahmed Lallem (1966), mettant en lumière les réflexions de lycéennes algériennes sur leur place dans une société post-coloniale marquée par les tensions entre hommes et femmes. Leurs témoignages, révèlent une réalité où les droits des femmes restent théoriques face à des pratiques persistantes comme la bigamie ou le harcèlement de rue. « Une fille qui pense, ça n’existe pas » ou « Une fille qui se fait embêter, c’est un spectacle », illustrent leur réduction à un simple corps, objet de regards et de jugements. Pour éviter de reproduire cette objectification, la planche utilise des gros plans sur leurs visages, disposés de manière à ce que leurs regards se croisent, symbolisant leur combat commun.Les portraits découpés, posés sur un fond rempli évoquent les barreaux d’une cellule de prison et les séparations sociales dénoncées dans le film. Le vide laissé par les découpes peut être interprété comme une lueur d’espoir ou, au contraire, comme l’oubli des visages effacés. Les couleurs du drapeau algérien (vert, blanc, rouge) renforcent l’ancrage politique, tandis que la technique du papier découpé souligne la fragilité et la mobilité des mémoires. Chaque fragment devient un appel à se pencher sur ces histoires, à écouter ces voix trop souvent réduites au silence. L’objectif est clair : rendre visibles leurs pensées, leurs paroles et leurs luttes.",
        imageUrl: ellesCover,
        width: 600,
        height: 400,
        link: "/projets/elles",
        medias: [
          {
            type: "image",
            src: ellesFanzine01,
            alt: "Couverture du fanzine",
          },
          {
            type: "image",
            src: ellesFanzine02,
            alt: "Couverture du fanzine",
          },
          {
            type: "image",
            src: ellesPlanche01,
            alt: "Planche du film Elles",
          },
          {
            type: "image",
            src: ellesPlanche02,
            alt: "Planche imprimée du film Elles",
          },
        ],
      },
      {
        id: "bam",
        category: "Édition",
        title: "BAM MAGAZINE",
        date: "2025",
        brief:
          "Conception et réalisation, en collaboration, d’un magazine d’art contemporain intitulé BAM (Beyond Art Movements). Le projet consiste en la création d’un magazine de 12 pages, à partir d’articles et de photographies imposés.",
        softwares: ["InDesign"],
        creativeProcess:
          "Le projet se concentre sur la hiérarchie visuelle et la construction d’une identité graphique cohérente. Un chemin de fer et un layout précis ont structuré le magazine en amont, facilitant la création des gabarits. L’usage des styles de paragraphes et le choix typographique ont permis une mise en page lisible, équilibrée et harmonieuse.",
        imageUrl: bamCover,
        width: 600,
        height: 400,
        link: "/projets/bam",
        medias: [
          {
            type: "image",
            src: bam01,
            alt: "Couvertures du magazine BAM",
          },
          {
            type: "image",
            src: bam02,
            alt: "Pages du magazine BAM",
          },
          {
            type: "image",
            src: bam03,
            alt: "Pages du magazine BAM",
          },
          {
            type: "image",
            src: bam04,
            alt: "Pages du magazine BAM",
          },
          {
            type: "image",
            src: bam05,
            alt: "Pages du magazine BAM",
          },
          {
            type: "image",
            src: bam06,
            alt: "Pages du magazine BAM",
          },
        ],
      },
      {
        id: "operation-cocktail",
        category: "Édition",
        title: "OPÉRATION COCKTAIL",
        date: "2025",
        brief:
          "Conception et réalisation d’une bande dessinée jeunesse intitulée : Opération Cocktail. Le projet prévoit la réalisation de 4 pages intégrant un minimum de 24 cases.",
        softwares: ["Photoshop"],
        creativeProcess:
          "Créer une bande dessinée jeunesse sans recourir aux bulles de dialogue, en s’appuyant uniquement sur l’illustration pour faire comprendre l’histoire. Création de personnages dont la personnalité se traduit à travers leur design. Le personnage excentrique se distingue par une coiffure afro ébouriffée et de larges jambes, tandis que le personnage réservé adopte une silhouette fine et porte un col roulé, renforçant son attitude discrète.",
        synopsis:
          "Quand deux jeunes filles décident de sauver une crevette d’un poissonnier, elles ne se doutent pas qu’elles vont plonger dans une aventure rocambolesque qui les mènera au mystérieux royaume des crevettes.",
        imageUrl: operationCocktailCover,
        width: 600,
        height: 400,
        link: "/projets/operation-cocktail",
        medias: [
          {
            type: "image",
            src: operationCocktail00,
            alt: "Couverture Opération Cocktail",
          },
          {
            type: "image",
            src: operationCocktail01,
            alt: "Page 1 Opération Cocktail",
          },
          {
            type: "image",
            src: operationCocktail02,
            alt: "Page 2 Opération Cocktail",
          },
          {
            type: "image",
            src: operationCocktail03,
            alt: "Page 3 Opération Cocktail",
          },
          {
            type: "image",
            src: operationCocktail04,
            alt: "Page 4 Opération Cocktail",
          },
          {
            type: "image",
            src: operationCocktail05,
            alt: "Couverture Opération Cocktail",
          },
        ],
      },
      {
        id: "amasa",
        category: "Édition",
        title: "AMASA",
        date: "2024",
        brief:
          "Conception et réalisation d'un logo et d'un catalogue pour Amasa, une boutique japonaise haut de gamme.",
        softwares: ["Photoshop", "InDesign"],
        creativeProcess:
          "La conception du logo et du catalogue s’est articulée autour d’un équilibre entre élégance contemporaine et références culturelles subtiles. Le travail d'identité visuelle a débuté par une recherche iconographique sur l’esthétique japonaise traditionnelle (minimalisme, raffinement typographique, motifs naturels), confrontée à des codes graphiques plus actuels du luxe discret.",
        imageUrl: amasaCover,
        width: 600,
        height: 400,
        link: "/projets/amasa",
        medias: [
          {
            type: "image",
            src: amasa00,
            alt: "Couvertures Amasa",
          },
          {
            type: "image",
            src: amasa01,
            alt: "Pages 02-03 Amasa",
          },
          {
            type: "image",
            src: amasa02,
            alt: "Pages 04-05 Amasa",
          },
          {
            type: "image",
            src: amasa03,
            alt: "Pages 06-07 Amasa",
          },
          {
            type: "image",
            src: amasa04,
            alt: "Pages 08-09 Amasa",
          },
          {
            type: "image",
            src: amasa05,
            alt: "Pages 10-11 Amasa",
          },
          {
            type: "image",
            src: amasaStore,
            alt: "Magasin Amasa",
          },
        ],
      },
    ],
  },
  {
    category: "Motion design",
    projects: [
      {
        id: "introduce-yourself",
        category: "Motion design",
        title: "INTRODUCE YOURSELF",
        date: "2025",
        brief:
          "Conception et réalisation d’une série de pictogrammes illustrant les traits qui définissent notre identité, suivie d’une animation les mettant en scène.",
        softwares: ["After Effects", "Photoshop"],
        creativeProcess:
          "La première piste graphique s’organisait autour du carré : personnage et typographie étaient strictement confinés dans un cadre, dans une approche d’icônes. La seconde proposition puise dans l’univers des mangas et de l’humour japonais. Le « é » du logo évoque la chevelure du personnage, créant un lien graphique entre la typographie et l’illustration. L’animation 2D est réalisée en combinant des images dessinées à la main sous Photoshop et bouclées et transformées avec After Effects, inspiré de l’animation japonaise.",
        imageUrl: introduceYourselfCover,
        width: 600,
        height: 400,
        link: "/projets/introduce-yourself",
        medias: [
          {
            type: "vimeo",
            src: "https://player.vimeo.com/video/1066547133?h=604227c811",
            alt: "Animation Introduce Yourself",
          },
          {
            type: "image",
            src: introduceYourselfCharacters,
            alt: "Personnages",
          },
        ],
      },
      {
        id: "bo-setterlind",
        category: "Motion design",
        title: "BO SETTERLIND",
        date: "2025",
        brief:
          "Conception et réalisation d’une animation sur un poème de l’auteur suédois Bo Setterlind.",
        softwares: ["After Effects", "Photoshop"],
        creativeProcess:
          "L’esthétique s’inspire de l’artiste algérienne Baya, avec des formes simples et colorées issues de l’art naïf et de l’art brut. La composition est pensée à la manière de Melissa Castrillón, notamment dans l’usage des blancs qui permettent d’intégrer le texte comme un élément à part entière de l’illustration, sans rupture visuelle. Les plans sont dessinés sous Photoshop puis animés dans After Effects.",
        imageUrl: boSetterlindCover,
        width: 600,
        height: 400,
        link: "/projets/bo-setterlind",
        medias: [
          {
            type: "vimeo",
            src: "https://player.vimeo.com/video/1081160437?h=e48a028554",
            alt: "Animation Bo Setterlind",
          },
        ],
      },
      {
        id: "garden-life",
        category: "Motion design",
        title: "GARDEN LIFE",
        date: "2024",
        brief:
          "Conception et réalisation d’une boucle animée représentant un paysage en mouvement, où chaque élément évolue en continu pour créer un ensemble fluide et vivant..",
        softwares: ["After Effects", "Illustrator"],
        creativeProcess:
          "Réalisation d’une courte animation racontant la découverte d’un jardin. La technique du parenting a été utilisée pour animer les trajectoires et les ailes du papillon, facilitant des mouvements précis, cohérents et rapides à ajuster.",
        imageUrl: gardenLifeCover,
        width: 600,
        height: 400,
        link: "/projets/garden-life",
        medias: [
          {
            type: "vimeo",
            src: "https://player.vimeo.com/video/1081156394?h=8e3ff887c8",
            alt: "Animation Garden Life",
          },
        ],
      },
      {
        id: "cadavre-exquis",
        category: "Motion design",
        title: "CADAVRE EXQUIS ANIMÉ",
        date: "2026",
        brief:
          "Conception et réalisation d’une animation collaborative avec pour objectif de détourner un objet du quotidien.",
        softwares: ["After Effects", "Blender"],
        creativeProcess:
          "Réalisation d’une vidéo collective autour d’un objet unique, le micro-ondes, détourné de son usage initial. La principale difficulté a été de créer une cohérence entre trois vidéos utilisant des techniques différentes. Le choix d’une musique commune, d’un sound design récurrent servant de fil conducteur et d’un cadrage identique a permis d’assurer l’unité et la fluidité des transitions. Pour la première animation, j’ai utilisé Blender et After Effects, la deuxième animation a été réalisée par Sacha Goral, enfin la troisème animation a été réalisée par Lucie Blott.",
        imageUrl: cadavreExquisCover,
        width: 600,
        height: 400,
        link: "/projets/cadavre-exquis",
        medias: [
          {
            type: "vimeo",
            src: "https://player.vimeo.com/video/1168079187",
            alt: "Animation Cadavre exquis animé",
          },
        ],
      },
    ],
  },
  {
    category: "Typographie",
    projects: [
      {
        id: "bagnolet",
        category: "Typographie",
        title: "TYPOGRAPHIE DE BAGNOLET",
        date: "2026",
        brief:
          "Création d'un caractère typographique original inspiré par la ville de Bagnolet, sa matière, son rythme, ses habitants, son atmosphère, ses formes et ses mots.",
        softwares: [
          "Illustrator",
          "InDesign",
          "Lightroom",
          "Photographie argentique",
        ],
        creativeProcess:
          "Des entretiens avec les habitants de la ville de Bagnolet ont servi de base à cette typographie. Les lettres, inspirées des récits recueillis, traduisent visuellement et une ville pensée pour les flux et non pour le bien-être des usagers avec une architecture étouffante et imposée.",
        imageUrl: bagnoletCover,
        width: 600,
        height: 400,
        link: "/projets/bagnolet",
        medias: [
          {
            type: "image",
            src: bagnoletTypo01,
            alt: "Typo Majuscule",
          },
          {
            type: "image",
            src: bagnoletTypo02,
            alt: "Typo Minuscule",
          },
          {
            type: "image",
            src: bagnoletTypo03,
            alt: "Typo signes",
          },
          {
            type: "image",
            src: bagnoletArchitecture01,
            alt: "Architecture 01",
          },
          {
            type: "image",
            src: bagnoletEx01,
            alt: "Exploration 01",
          },
          {
            type: "image",
            src: bagnoletEx02,
            alt: "Exploration 02",
          },
          {
            type: "image",
            src: bagnoletArchitecture02,
            alt: "Architecture 02",
          },
          {
            type: "image",
            src: bagnoletArchitecture03,
            alt: "Architecture 03",
          },
          {
            type: "image",
            src: bagnoletArchitecture04,
            alt: "Architecture 04",
          },
        ],
      },
      {
        id: "volapuk",
        category: "Typographie",
        title: "ALPHABET VOLAPÜK",
        date: "2025",
        brief:
          "Conception et réalisation d’un l’alphabet fictif non latin, à partir d’une typographie modifiée, déconstruitre, réassemblée puis vectorisée.",
        softwares: ["Illustrator", "Papier découpé"],
        creativeProcess:
          "Le Volapük est une langue inventée en 1880 par Johann Martin Schleyer, un prêtre catholique allemand, dans le but d’unir l’humanité. Cette écriture fictive et universelle prolonge sa vision. Le sens de lecture s’effectue du haut vers le bas et de la gauche vers la droite, représentant la verticalité de la religion chrétienne et le schéma de la trinité. L’alphabet est créé à partir de la typographie EB Garamond, uniformisée selon des normes communes, déconstruite puis réassemblée selon une grille, avec des croquis pour assurer l’harmonie et la cohérence des formes.",
        imageUrl: volapukCover,
        width: 600,
        height: 400,
        link: "/projets/volapuk",
        medias: [
          {
            type: "image",
            src: volapukAlphabet,
            alt: "Alphabet du Volapük",
          },
          {
            type: "image",
            src: volapukCroquis01,
            alt: "Croquis du Volapük",
          },
          {
            type: "image",
            src: volapukCroquis02,
            alt: "Croquis du Volapük",
          },
        ],
      },
    ],
  },
  {
    category: "Campagne d'affichage",
    projects: [
      {
        id: "innocence-en-danger",
        category: "Campagne d'affichage",
        title: "INNOCENCE EN DANGER",
        date: "2025",
        brief:
          "Réalisation d’une campagne d’affichage pour l’association Innoncence en danger. L’objectif est de mélanger photographie et illustration afin de donner un second sens au visuel.",
        softwares: ["Illustrator"],
        creativeProcess:
          "Création d’une série d’affiches dénonçant les violences sexuelles faites aux enfants, en particulier l’inceste. Chaque visuel associe une accroche percutante au champ lexical des prédateurs et des monstres, illustrant symboliquement les agresseurs. Des enfants déguisés, souriants mais en larmes, sont entourés de griffes dessinées, créant un contraste entre l’innocence et la menace. L’alliance de photographie et d’illustration permet de traiter ce sujet sensible avec force et pudeur.",
        imageUrl: innocenceDangerCover,
        width: 600,
        height: 400,
        link: "/projets/innocence-en-danger",
        medias: [
          {
            type: "image",
            src: innocenceDangerPoster01,
            alt: "Première affiche InnocenceDanger",
          },
          {
            type: "image",
            src: innocenceDangerPoster02,
            alt: "Deuxième affiche InnocenceDanger",
          },
          {
            type: "image",
            src: innocenceDangerPoster03,
            alt: "Troisième affiche InnocenceDanger",
          },
        ],
      },
    ],
  },
  {
    category: "Développement Web",
    projects: [
      {
        id: "kasa",
        category: "Développement Web",
        title: "KASA",
        date: "2023",
        brief: "",
        softwares: ["VSCode", "React"],
        creativeProcess: "",
        imageUrl: kasaCover,
        width: 600,
        height: 400,
        link: "/projets/kasa",
        medias: [
          {
            type: "vimeo",
            src: "https://player.vimeo.com/video/896180508?h=99c731a1d0",
            alt: "Powerpoint Kasa",
          },
        ],
      },
      {
        id: "site-client",
        category: "Développement Web",
        title: "Site client",
        date: "2023",
        brief: "",
        softwares: ["VSCode", "HTML", "CSS", "JS"],
        creativeProcess: "",
        imageUrl: portfolioCover,
        width: 600,
        height: 400,
        link: "/projets/site-client",
        medias: [
          {
            type: "vimeo",
            src: "https://player.vimeo.com/video/896185780?h=62260b0e46",
            alt: "Powerpoint Portfolio",
          },
          {
            type: "image",
            src: portfolioHome,
            alt: "Home du portfolio",
          },
          {
            type: "image",
            src: portfolioContact,
            alt: "Formulaire de contact du portfolio",
          },
          {
            type: "image",
            src: portfolioLogin,
            alt: "Page de connexion du portfolio",
          },
          {
            type: "image",
            src: portfolioMenu,
            alt: "Menu de personnalisation du portfolio",
          },
        ],
      },
      {
        id: "riding-cities",
        category: "Développement Web",
        title: "RIDING CITIES",
        date: "2023",
        brief: "",
        softwares: ["VSCode", "HTML", "CSS"],
        creativeProcess: "",
        imageUrl: ridingCitiesCover,
        width: 600,
        height: 400,
        link: "/projets/riding-cities",
        medias: [
          {
            type: "vimeo",
            src: "https://player.vimeo.com/video/896184397?h=690f60bca",
            alt: "Powerpoint Riding Cities",
          },
        ],
      },
    ],
  },
];
